import { Controller } from "stimulus";

const ERROR_CLASS = "field-with-error";

export default class extends Controller {
  static get targets() {
    return ["form"];
  }

  connect() {
    const form = $(this.formTarget);
    form.on("ajax:success", this.onSuccess);
    form.on("ajax:error", this.onError);
  }

  disconnect() {
    const form = $(this.formTarget);
    form.off("ajax:success");
    form.off("ajax:error");
  }

  onSuccess = (_event, _data, _status, xhr) => {
    this.clearFieldErrors();
    window.location = `${xhr.getResponseHeader("Location")}/services`;
  };

  onError = (_xhr, error) => {
    const errors = error.responseJSON || {};
    this.clearFieldErrors();
    this.renderFieldErrors(errors);
    const fieldError = document.querySelector(`.${ERROR_CLASS}`);
    window.scrollTo({
      top: fieldError.getBoundingClientRect().top + window.pageYOffset - 60,
      behavior: "smooth",
    });
  };

  clearFieldErrors() {
    const fieldErrors = this.formTarget.querySelectorAll(`.${ERROR_CLASS}`);
    fieldErrors.forEach((fieldError) => {
      fieldError.classList.remove(ERROR_CLASS);
    });
  }

  renderFieldErrors(errors) {
    const coverPictureSelector =
      "#artistic_profile_cover_picture_attributes_id";
    const profilePictureSelector =
      "#artistic_profile_profile_picture_attributes_id";
    Object.entries(errors).forEach(([key, value]) => {
      let field = this.formTarget.querySelector(
        `[name="artistic_profile[${key}]"]`,
      );

      if (key === "cover_picture") {
        field = this.formTarget.querySelector(coverPictureSelector);
      }

      if (key === "profile_picture") {
        field = this.formTarget.querySelector(profilePictureSelector);
      }

      const fallbackError = `${I18n.t(`shared.errors.${key}`)} ${value}`;
      const finalErrorMessage = I18n.t(`shared.errors.${value}`, {
        defaultValue: fallbackError,
      });

      if (field) {
        const formGroup = field.closest(".form-group");
        formGroup.classList.add(ERROR_CLASS);
        formGroup.querySelector(".error-message").textContent =
          finalErrorMessage;
      }
    });
  }
}
